import Api from './Api'

export default {
    get(pageNumber) {
        return Api().get(`notifications?pageNumber=${pageNumber}`);
    },
    getQntPendente() {
        return Api().get(`notifications/pendentes`);
    },
    update(idNotification){
        return Api().put('notifications/update/visualizado', idNotification);
    }
}